export enum PrivacyTypeEnum {
    SALES = 'sales',
    MARKETING = 'marketing',
}